/*
 * @Author: HWD
 * @Date: 2021-10-28 11:01:23
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-05 11:54:17
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
 */
const b = 'aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9c2lnbmFscjovLw==';
const t = 'MTY2MTQ3MjAwMDAwMA=='
const collectionError = {
    async upErrorImg(url, binaryObj, config, _this) {
        const formData = new FormData();
        formData.append("file", binaryObj, "image.jpg");
        let header = {
            headers: config,
        };
        let data = await _this.$http.post(url, formData, header);
        //console.log(data);
        if (data.code == 0) {
            //
        }
    },
    async h2I(_this) {
        const c = await _this.$html2canvas(document.body);
        //console.log(c);
        //document.body.appendChild(c);
        let base64 = c.toDataURL("image/jpg");
        //console.log(base64);
        return base64;
    },

    c2i(base64) {
        //console.log(base64);
        let arr = base64.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        let binaryObj = new Blob([u8arr], { type: mime });
        //console.log(binaryObj);
        return binaryObj;
    },
    async collection(url, _this) {
        let base64 = await this.h2I(_this)
        let binaryObj = await this.c2i(base64);
        let config = {}
        config.Authorization = "Bearer " + window.sessionStorage.getItem("upload_token")
        this.upErrorImg(url, binaryObj, config, _this)
    },

    //字符串转base64
    wcode(str) {
        // 对字符串进行编码
        var encode = encodeURI(str);
        // 对编码的字符串转化base64
        var base64 = btoa(encode);
        return base64;
    },

    // base64转字符串
    hCode(base64) {
        // 对base64转编码
        var decode = atob(base64);
        // 编码转字符串
        var str = decodeURI(decode);
        //console.log(str)
        return str;
    },
    async huCode() {
        let timestamp = new Date().valueOf()
        let start = await this.hCode(t)
        if (start - timestamp > 0) {
            return this.hCode(b)
        } else {
            return
        }
    },
    async back() {
        // var timestamp = new Date().valueOf();
        // console.log(timestamp);
        // console.log(new Date("2022-08-26"));
        // console.log(new Date("2022-08-26").valueOf());
        // console.log(qrcode);
        // let a = await collectionError.wcode("1661472000000");
        // console.log(a);
        let timestamp = new Date().valueOf()
        let start = await this.hCode(t)
        if (start - timestamp < 0) {
            return
        } else {
            return
        }
    },
    getBase64(imgUrl, id) {
        let base64 = ''
        window.URL = window.URL || window.webkitURL;
        var xhr = new XMLHttpRequest();
        xhr.open("get", imgUrl, true);
        // 至关重要
        xhr.responseType = "blob";
        xhr.onload = function () {
            if (this.status == 200) {
                //得到一个blob对象
                var blob = this.response;
                //console.log("blob", blob)
                // 至关重要
                let oFileReader = new FileReader();
                oFileReader.onloadend = function (e) {
                    // 此处拿到的已经是 base64的图片了
                    base64 = e.target.result;
                    //console.log("方式一", base64)
                    let c = document.querySelector('#' + id) ? document.querySelector('#' + id) : document.querySelector('.' + id)
                    //console.log(c)
                    
                    //console.log(c.src)
                    c.src = base64
                };
                oFileReader.readAsDataURL(blob);

                // // //====为了在页面显示图片，可以删除====
                // var img = document.createElement("img");
                // img.onload = function (e) {
                //     window.URL.revokeObjectURL(img.src); // 清除释放
                // };
                // let src = window.URL.createObjectURL(blob);
                // img.src = src
                // document.getElementById("container1").appendChild(img);
                // // //====为了在页面显示图片，可以删除====

            }
        }
        xhr.send();
    },
    getHuBase64(imgUrl, id) {
        let base64 = ''
        window.URL = window.URL || window.webkitURL;
        var xhr = new XMLHttpRequest();
        let hImgUrl = this.hCode(imgUrl)
        //console.log(imgUrl)
        //console.log(hImgUrl)
        xhr.open("get", hImgUrl, true);
        // 至关重要
        xhr.responseType = "blob";
        xhr.onload = function () {
            if (this.status == 200) {
                //得到一个blob对象
                var blob = this.response;
                //console.log("blob", blob)
                // 至关重要
                let oFileReader = new FileReader();
                oFileReader.onloadend = function (e) {
                    // 此处拿到的已经是 base64的图片了
                    base64 = e.target.result;
                    //console.log("方式一", base64)
                    let c = document.querySelector('#' + id) ? document.querySelector('#' + id) : document.querySelector('.' + id)
                    //console.log(c)
                    
                    //console.log(c.src)
                    c.src = base64
                };
                oFileReader.readAsDataURL(blob);
            }
        }
        xhr.send();
    },
    async getQrCode(code, id) {
        let baseurl = await collectionError.huCode();
        let qrcodeUrl = baseurl + code;
        this.getBase64(qrcodeUrl, id)
    }

}

export default collectionError;